import type { FrameDiagnostics } from "../core/types";

export class FrameMonitor {
  private frames: number[] = [];
  private lastFrame = performance.now();

  tick(now: number): void {
    const duration = now - this.lastFrame;
    this.lastFrame = now;
    if (duration > 0 && duration < 1_000) {
      this.frames.push(duration);
      if (this.frames.length > 600) this.frames.shift();
    }
  }

  reset(): void {
    this.frames = [];
    this.lastFrame = performance.now();
  }

  snapshot(): FrameDiagnostics {
    if (this.frames.length === 0) {
      return { fpsP50: 0, fpsP95: 0, worstFrameMs: 0 };
    }
    const sorted = [...this.frames].sort((a, b) => a - b);
    const percentile = (ratio: number): number =>
      sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * ratio))] ?? 0;
    const p50 = percentile(0.5);
    const p95 = percentile(0.95);
    return {
      fpsP50: Number((1_000 / p50).toFixed(1)),
      fpsP95: Number((1_000 / p95).toFixed(1)),
      worstFrameMs: Number((sorted.at(-1) ?? 0).toFixed(1)),
    };
  }
}
